import LogoHmarochos from '../img/hmarochos_logo.svg';
import styles from '../Quiz.module.css'

export const Loader = () => {
    return <div className={`${styles.loader} card `}>
        <img src={LogoHmarochos} alt="Hmarochos" />
    </div>
}
